import React from "react";
import { Typography } from "@mui/material";

/**
 * Txt — wrapper around MUI Typography.
 *
 * IMPORTANT: defaults to component="span". Vertical margins (mt/mb) are silently
 * ignored on inline elements. If you need vertical spacing between Txt nodes,
 * wrap them in <Flx column gap={...}> rather than relying on default block flow.
 * If you really need a block-level Txt, pass component="div" or component="p".
 */
const Txt = React.forwardRef(function Txt(
  { component = "span", variant = "body2", color, sx, children, ...rest },
  ref
) {
  return (
    <Typography
      ref={ref}
      component={component}
      variant={variant}
      color={color}
      sx={sx}
      {...rest}
    >
      {children}
    </Typography>
  );
});

export default Txt;
